
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/travel-and-tourism",
      function () {
        return require("private-next-pages/investments/travel-and-tourism.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/travel-and-tourism"])
      });
    }
  